<div class="main-wrapper">
  <!-- ===== LEFT PANEL ===== -->
  <aside class="left-panel" [ngClass]="{ 'left-panel--collapsed': !showStepper }">
    <div class="gradient-overlay"></div>
    <div class="floating-blob blob-1"></div>
    <div class="floating-blob blob-2"></div>
    <div class="line-pattern"></div>

    <button class="stepper-toggle-btn" type="button" (click)="toggleStepper()"
      [title]="showStepper ? 'Collapse sidebar' : 'Expand sidebar'">
      <i class="bi bi-chevron-double-left toggle-icon" [class.rotated]="!showStepper"></i>
    </button>

    <!-- Mini Stepper -->
    <div class="mini-stepper" *ngIf="!showStepper">
      <div class="mini-step-item" *ngFor="let i of [0, 1, 2, 3, 4, 5, 6]" [class.active]="activeStep === i"
        [class.completed]="isStepCompleted(i)" (click)="setStep(i)" [title]="
          [
            'Mobile & Station',
            'Trader Details',
            'Address Info',
            'Operations',
            'Users',
            'Documents',
            'Preview',
          ][i]
        ">
        <div class="mini-step-circle">
          <i *ngIf="isStepCompleted(i)" class="bi bi-check2"></i>
          <span *ngIf="!isStepCompleted(i)">{{ i + 1 }}</span>
        </div>
        <div class="mini-connector" *ngIf="i < 6"></div>
      </div>
    </div>

    <div class="left-content-wrap" [class.stepper-content--hidden]="!showStepper" [class.stepper-ready]="stepperReady">
      <div class="logo-area">
        <div class="logo-circle">
          <img src="TNPGCL_logo.png" alt="TNPGCL Logo" />
        </div>
        <div class="logo-labels">
          <h1 class="portal-title-text">Ash <span class="green-accent">Disposal Portal</span></h1>
        </div>
      </div>

      <!-- Stepper -->
      <div class="stepper">
        <!-- Step 1 -->
        <div class="step-item" [class.active]="activeStep === 0" [class.completed]="isStepCompleted(0)"
          (click)="setStep(0)">
          <div class="step-circle" [class.active]="activeStep === 0" [class.completed]="isStepCompleted(0)">
            <span *ngIf="!isStepCompleted(0)">1</span>
            <i *ngIf="isStepCompleted(0)" class="bi bi-check-lg"></i>
          </div>
          <div class="step-content">
            <div class="step-title">STATION & TYPE</div>
            <div class="step-desc">Verify mobile & select power station</div>
          </div>
          <div class="step-status-badge">
            <span class="badge completed-badge" *ngIf="isStepCompleted(0)">Done</span>
            <span class="badge active-badge" *ngIf="activeStep === 0 && !isStepCompleted(0)">Active</span>
          </div>
        </div>

        <!-- Step 2 -->
        <div class="step-item" [class.active]="activeStep === 1" [class.completed]="isStepCompleted(1)"
          (click)="isStepCompleted(0) && setStep(1)">
          <div class="step-circle" [class.active]="activeStep === 1" [class.completed]="isStepCompleted(1)">
            <span *ngIf="!isStepCompleted(1)">2</span>
            <i *ngIf="isStepCompleted(1)" class="bi bi-check-lg"></i>
          </div>
          <div class="step-content">
            <div class="step-title">TRADER DETAILS</div>
            <div class="step-desc">GST, PAN, Tariff & more</div>
          </div>
          <div class="step-status-badge">
            <span class="badge completed-badge" *ngIf="isStepCompleted(1)">Done</span>
            <span class="badge active-badge" *ngIf="activeStep === 1 && !isStepCompleted(1)">Active</span>
          </div>
        </div>

        <!-- Step 3 -->
        <div class="step-item" [class.active]="activeStep === 2" [class.completed]="isStepCompleted(2)"
          (click)="isStepCompleted(1) && setStep(2)">
          <div class="step-circle" [class.active]="activeStep === 2" [class.completed]="isStepCompleted(2)">
            <span *ngIf="!isStepCompleted(2)">3</span>
            <i *ngIf="isStepCompleted(2)" class="bi bi-check-lg"></i>
          </div>
          <div class="step-content">
            <div class="step-title">ADDRESS INFO</div>
            <div class="step-desc">Trader address details</div>
          </div>
          <div class="step-status-badge">
            <span class="badge completed-badge" *ngIf="isStepCompleted(2)">Done</span>
            <span class="badge active-badge" *ngIf="activeStep === 2 && !isStepCompleted(2)">Active</span>
          </div>
        </div>

        <!-- Step 4 -->
        <div class="step-item" [class.active]="activeStep === 3" [class.completed]="isStepCompleted(3)"
          (click)="isStepCompleted(2) && setStep(3)">
          <div class="step-circle" [class.active]="activeStep === 3" [class.completed]="isStepCompleted(3)">
            <span *ngIf="!isStepCompleted(3)">4</span>
            <i *ngIf="isStepCompleted(3)" class="bi bi-check-lg"></i>
          </div>
          <div class="step-content">
            <div class="step-title">OPERATIONS</div>
            <div class="step-desc">Ash details</div>
          </div>
          <div class="step-status-badge">
            <span class="badge completed-badge" *ngIf="isStepCompleted(3)">Done</span>
            <span class="badge active-badge" *ngIf="activeStep === 3 && !isStepCompleted(3)">Active</span>
          </div>
        </div>

        <!-- Step 5 -->
        <div class="step-item" [class.active]="activeStep === 4" [class.completed]="isStepCompleted(4)"
          (click)="isStepCompleted(3) && setStep(4)">
          <div class="step-circle" [class.active]="activeStep === 4" [class.completed]="isStepCompleted(4)">
            <span *ngIf="!isStepCompleted(4)">5</span>
            <i *ngIf="isStepCompleted(4)" class="bi bi-check-lg"></i>
          </div>
          <div class="step-content">
            <div class="step-title">USERS</div>
            <div class="step-desc">User list</div>
          </div>
          <div class="step-status-badge">
            <span class="badge completed-badge" *ngIf="isStepCompleted(4)">Done</span>
            <span class="badge active-badge" *ngIf="activeStep === 4 && !isStepCompleted(4)">Active</span>
          </div>
        </div>

        <!-- Step 6 -->
        <div class="step-item" [class.active]="activeStep === 5" [class.completed]="isStepCompleted(5)"
          (click)="isStepCompleted(4) && setStep(5)">
          <div class="step-circle" [class.active]="activeStep === 5" [class.completed]="isStepCompleted(5)">
            <span *ngIf="!isStepCompleted(5)">6</span>
            <i *ngIf="isStepCompleted(5)" class="bi bi-check-lg"></i>
          </div>
          <div class="step-content">
            <div class="step-title">UPLOAD DOCUMENTS</div>
            <div class="step-desc">Supporting certificates</div>
          </div>
          <div class="step-status-badge">
            <span class="badge completed-badge" *ngIf="isStepCompleted(5)">Done</span>
            <span class="badge active-badge" *ngIf="activeStep === 5 && !isStepCompleted(5)">Active</span>
          </div>
        </div>

        <!-- Step 7 -->
        <div class="step-item" [class.active]="activeStep === 6" [class.completed]="isStepCompleted(6)"
          (click)="isStepCompleted(5) && setStep(6)">
          <div class="step-circle" [class.active]="activeStep === 6" [class.completed]="isStepCompleted(6)">
            <span *ngIf="!isStepCompleted(6)">7</span>
            <i *ngIf="isStepCompleted(6)" class="bi bi-check-lg"></i>
          </div>
          <div class="step-content">
            <div class="step-title">PREVIEW APPLICATION</div>
            <div class="step-desc">Review & submit</div>
          </div>
          <div class="step-status-badge">
            <span class="badge completed-badge" *ngIf="isStepCompleted(6)">Done</span>
            <span class="badge active-badge" *ngIf="activeStep === 6 && !isStepCompleted(6)">Active</span>
          </div>
        </div>
      </div>
    </div>
  </aside>

  <!-- ===== RIGHT PANEL ===== -->
  <main class="right-panel">
    <!-- Hero Banner -->
    <div class="hero-banner">
      <div class="hero-banner-inner">
        <div class="hero-text-content">
          <div class="hero-badge">
            <span class="hero-badge-dot"></span>
            Tamil Nadu Power Generation Corporation Limited
          </div>
          <h1 class="hero-title">Trader <span class="hero-title-highlight">Registration</span></h1>
          <p class="hero-subtitle">
            Register your trading organization and manage ash allocation digitally through the
            TNPGCL Ash Portal.
          </p>
          <div class="hero-feature-row mt-3">
            <div class="hero-feature">
              <div class="hero-feature-icon"><i class="bi bi-shield-check"></i></div>
              <div class="hero-feature-text">
                <span class="hero-feature-label">Secure</span><span class="hero-feature-sub">Registration</span>
              </div>
            </div>
            <div class="hero-feature">
              <div class="hero-feature-icon"><i class="bi bi-check2-square"></i></div>
              <div class="hero-feature-text">
                <span class="hero-feature-label">Online</span><span class="hero-feature-sub">Verification</span>
              </div>
            </div>
            <div class="hero-feature">
              <div class="hero-feature-icon"><i class="bi bi-lightning-charge"></i></div>
              <div class="hero-feature-text">
                <span class="hero-feature-label">Fast</span><span class="hero-feature-sub">Approval</span>
              </div>
            </div>
            <div class="hero-feature">
              <div class="hero-feature-icon"><i class="bi bi-patch-check"></i></div>
              <div class="hero-feature-text">
                <span class="hero-feature-label">100%</span><span class="hero-feature-sub">Digital Process</span>
              </div>
            </div>
          </div>
        </div>
        <div class="hero-eco-badge">
          <img src="TNPGCL_logo.png" alt="TNPGCL Government Logo" class="hero-gov-logo" />
        </div>
      </div>
    </div>

    <div class="form-card">
      <!-- Resume Draft action -->
      <div class="form-card-actions" *ngIf="activeStep < 6">
        <button type="button" class="btn-resume-draft" (click)="onResumeDraft()" [disabled]="isLoadingDraft">
          <span *ngIf="isLoadingDraft" class="spinner-border spinner-border-sm me-1" role="status"
            aria-hidden="true"></span>
          <i *ngIf="!isLoadingDraft" class="bi bi-arrow-counterclockwise"></i>
          {{ isLoadingDraft ? 'Loading Draft...' : 'Resume Draft' }}
        </button>
      </div>

      <!-- Progress bar -->
      <div class="form-progress-bar">
        <div class="form-progress-fill" [style.width.%]="getProgressPercent()"></div>
      </div>

      <form [formGroup]="registerForm" novalidate>
        <!-- ===== STEP 1: Mobile & Power Station ===== -->
        <div class="form-step" *ngIf="activeStep === 0">
          <div class="section-title d-flex align-items-center gap-2 mb-4">
            <i class="bi bi-phone-fill"></i>
            <h3 class="mb-0 fw-semibold text-uppercase">STATION & TYPE</h3>
          </div>
          <p class="section-desc">Verify your mobile number and select your power station.</p>

          <div class="row g-3">
            <!-- Mobile Number -->
            <div class="col-md-6 mt-3">
              <label class="form-label">Mobile Number <span class="required-star">*</span></label>
              <div class="phone-group">
                <div class="phone-prefix">
                  <span class="flag-emoji">🇮🇳</span>
                  <span>+91</span>
                </div>
                <input type="tel" class="form-control phone-input" placeholder="Enter 10-digit mobile number"
                  formControlName="mobileNumber" maxlength="10"
                  onkeypress="return event.charCode >= 48 && event.charCode <= 57;" />
              </div>
              <div class="mt-1" style="font-size: 11.5px; font-weight: 500">
                <div *ngIf="mobileCheckStatus === 'checking'" class="text-primary">
                  <span class="spinner-border spinner-border-sm me-1" role="status"></span> Checking
                  mobile number...
                </div>
                <div *ngIf="mobileCheckStatus === 'valid'" class="text-success">
                  <i class="bi bi-check-circle-fill"></i> Mobile number is valid.
                </div>
                <div *ngIf="
                    mobileCheckStatus === 'exists' ||
                    registerForm.get('mobileNumber')?.errors?.['alreadyRegistered']
                  " class="text-danger">
                  <i class="bi bi-exclamation-circle-fill"></i>
                  {{ mobileCheckErrorMsg || 'This mobile number is already registered!' }}
                </div>
                <div *ngIf="
                    registerForm.get('mobileNumber')?.touched &&
                    registerForm.get('mobileNumber')?.errors?.['required']
                  " class="text-danger">
                  Mobile number is required.
                </div>
                <div *ngIf="
                    registerForm.get('mobileNumber')?.touched &&
                    registerForm.get('mobileNumber')?.errors?.['pattern']
                  " class="text-danger">
                  Must be a valid 10-digit number.
                </div>
              </div>

              <!-- Generate OTP -->
              <div *ngIf="canGenerateMobileOtp" class="mobile-otp-actions mt-2">
                <button type="button" class="btn-generate-otp" (click)="onGenerateMobileOtp()"
                  [disabled]="mobileOtpGenerating">
                  <span *ngIf="!mobileOtpGenerating"><i class="bi bi-shield-lock"></i> Generate OTP</span>
                  <span *ngIf="mobileOtpGenerating"><span class="spinner-border spinner-border-sm me-1"
                      role="status"></span>
                    Generating OTP...</span>
                </button>
              </div>

              <!-- OTP Entry -->
              <div *ngIf="mobileOtpSent && !mobileOtpVerified" class="mobile-otp-section mt-3"
                [formGroup]="mobileOtpForm">
                <button type="button" class="btn-change-mobile" (click)="changeMobileNumber()">
                  <i class="bi bi-arrow-left"></i> Change mobile number
                </button>
                <label class="form-label mt-2">Enter 4-Digit OTP</label>
                <div class="mobile-otp-input-group" (paste)="onMobileOtpPaste($event)">
                  <input *ngFor="let field of mobileOtpFields; let i = index" [id]="field" type="text"
                    inputmode="numeric" maxlength="1" class="mobile-otp-input" [formControlName]="field"
                    autocomplete="one-time-code" (input)="onMobileOtpInput($event, field, i < 3 ? 'otp' + (i + 2) : '')"
                    (keydown)="onMobileOtpKeydown($event, field, i > 0 ? 'otp' + i : '')" />
                </div>
                <div class="mobile-resend-row mt-2">
                  <span>Didn't receive the code?</span>
                  <button type="button" class="btn-resend-mobile-otp" (click)="onResendMobileOtp()"
                    [disabled]="mobileOtpResendCountdown > 0 || mobileOtpResendLoading">
                    <span *ngIf="mobileOtpResendLoading">Resending...</span>
                    <span *ngIf="!mobileOtpResendLoading && mobileOtpResendCountdown > 0">Resend in {{
                      mobileOtpResendCountdown }}s</span>
                    <span *ngIf="!mobileOtpResendLoading && mobileOtpResendCountdown === 0">Resend OTP</span>
                  </button>
                </div>
                <div *ngIf="mobileOtpError" class="mobile-otp-error mt-2">
                  <i class="bi bi-exclamation-circle-fill"></i> {{ mobileOtpError }}
                </div>
                <button type="button" class="btn-verify-mobile-otp mt-2" (click)="onVerifyMobileOtp()"
                  [disabled]="mobileOtpVerifying || !isMobileOtpComplete">
                  <span *ngIf="!mobileOtpVerifying"><i class="bi bi-shield-check"></i> Verify OTP</span>
                  <span *ngIf="mobileOtpVerifying"><span class="spinner-border spinner-border-sm me-1"
                      role="status"></span>
                    Verifying...</span>
                </button>
              </div>

              <div *ngIf="mobileOtpVerified" class="text-success mt-2" style="font-size: 11.5px; font-weight: 600">
                <i class="bi bi-patch-check-fill"></i> Mobile number verified successfully.
              </div>
            </div>

            <!-- Power Station -->
            <div class="col-md-6 mb-3">
              <label class="form-label">Power Station <span class="required-star">*</span></label>
              <div class="input-wrapper">
                <i class="bi bi-building input-icon"></i>
                <select class="form-select" formControlName="station" style="padding-left: 30px">
                  <option value="" disabled selected>Select Power Station</option>
                  <option *ngFor="let s of powerStations" [value]="s.id">{{ s.name }}</option>
                </select>
                <div class="spinner-border spinner-border-sm select-loader" *ngIf="stationsLoading"></div>
              </div>
              <div *ngIf="registerForm.get('station')?.touched && registerForm.get('station')?.invalid"
                class="text-danger" style="font-size: 11.5px; margin-top: 4px; font-weight: 500">
                Power station is required.
              </div>
            </div>
          </div>

          <div class="form-navigation mt-4 pt-3 border-top d-flex justify-content-between align-items-center">
            <button type="button" class="btn-save-draft" (click)="onSaveDraft()"
              [disabled]="isSavingDraft || !canSaveDraft()">
              <span *ngIf="isSavingDraft" class="spinner-border spinner-border-sm me-1" role="status"
                aria-hidden="true"></span>
              <i *ngIf="!isSavingDraft" class="bi bi-save2"></i>
              {{ isSavingDraft ? 'Saving...' : 'Save Draft' }}
            </button>
            <button type="button" class="btn-next" (click)="nextStep()">
              Next Step<i class="bi bi-arrow-right"></i>
            </button>
          </div>
        </div>

        <!-- ===== STEP 2: Firm Details ===== -->
        <div class="form-step" *ngIf="activeStep === 1">
          <div class="section-title d-flex align-items-center gap-2 mb-4">
            <i class="bi bi-person-vcard-fill"></i>
            <h3 class="mb-0 fw-semibold text-uppercase">Trader Details</h3>
          </div>
          <p class="section-desc">
            Provide your firm/organization details and regulatory information.
          </p>

          <div class="row g-3">
            <div class="col-md-6">
              <label class="form-label">Trader Name <span class="required-star">*</span></label>
              <div class="input-wrapper">
                <i class="bi bi-buildings input-icon"></i>
                <input type="text" class="form-control" formControlName="firmName" placeholder="Enter trader name" />
              </div>
              <div *ngIf="
                  registerForm.get('firmName')?.touched && registerForm.get('firmName')?.invalid
                " class="text-danger" style="font-size: 11.5px; margin-top: 4px; font-weight: 500">
                Trader name is required.
              </div>
            </div>

            <div class="col-md-6">
              <label class="form-label">Email Address <span class="required-star">*</span></label>
              <div class="input-wrapper">
                <i class="bi bi-envelope input-icon"></i>
                <input type="email" class="form-control" formControlName="email" placeholder="example@domain.com" />
              </div>
              <div *ngIf="registerForm.get('email')?.touched && registerForm.get('email')?.invalid" class="text-danger"
                style="font-size: 11.5px; margin-top: 4px; font-weight: 500">
                <span *ngIf="registerForm.get('email')?.errors?.['required']">Email is required.</span>
                <span *ngIf="
                    registerForm.get('email')?.errors?.['email'] ||
                    registerForm.get('email')?.errors?.['pattern']
                  ">Please enter a valid email address.</span>
              </div>

              <!-- Generate Email OTP -->
              <div *ngIf="canGenerateEmailOtp" class="mobile-otp-actions mt-2">
                <button type="button" class="btn-generate-otp" (click)="onGenerateEmailOtp()"
                  [disabled]="emailOtpGenerating">
                  <span *ngIf="!emailOtpGenerating"><i class="bi bi-shield-lock"></i> Generate OTP</span>
                  <span *ngIf="emailOtpGenerating"><span class="spinner-border spinner-border-sm me-1"
                      role="status"></span>
                    Generating OTP...</span>
                </button>
              </div>

              <!-- Email OTP Entry -->
              <div *ngIf="emailOtpSent && !emailOtpVerified" class="mobile-otp-section mt-3" [formGroup]="emailOtpForm">
                <button type="button" class="btn-change-mobile" (click)="changeEmailAddress()">
                  <i class="bi bi-arrow-left"></i> Change email address
                </button>
                <label class="form-label mt-2">Enter 4-Digit OTP</label>
                <div class="mobile-otp-input-group" (paste)="onEmailOtpPaste($event)">
                  <input *ngFor="let field of emailOtpFields; let i = index" [id]="field + '-email'" type="text"
                    inputmode="numeric" maxlength="1" class="mobile-otp-input" [formControlName]="field"
                    autocomplete="one-time-code" (input)="
                      onEmailOtpInput($event, field, i < 3 ? 'otp' + (i + 2) + '-email' : '')
                    " (keydown)="onEmailOtpKeydown($event, field, i > 0 ? 'otp' + i + '-email' : '')" />
                </div>
                <div class="mobile-resend-row mt-2">
                  <span>Didn't receive the code?</span>
                  <button type="button" class="btn-resend-mobile-otp" (click)="onResendEmailOtp()"
                    [disabled]="emailOtpResendCountdown > 0 || emailOtpResendLoading">
                    <span *ngIf="emailOtpResendLoading">Resending...</span>
                    <span *ngIf="!emailOtpResendLoading && emailOtpResendCountdown > 0">Resend in {{
                      emailOtpResendCountdown }}s</span>
                    <span *ngIf="!emailOtpResendLoading && emailOtpResendCountdown === 0">Resend OTP</span>
                  </button>
                </div>
                <div *ngIf="emailOtpError" class="mobile-otp-error mt-2">
                  <i class="bi bi-exclamation-circle-fill"></i> {{ emailOtpError }}
                </div>
                <button type="button" class="btn-verify-mobile-otp mt-2" (click)="onVerifyEmailOtp()"
                  [disabled]="emailOtpVerifying || !isEmailOtpComplete">
                  <span *ngIf="!emailOtpVerifying"><i class="bi bi-shield-check"></i> Verify OTP</span>
                  <span *ngIf="emailOtpVerifying"><span class="spinner-border spinner-border-sm me-1"
                      role="status"></span>
                    Verifying...</span>
                </button>
              </div>

              <div *ngIf="emailOtpVerified" class="text-success mt-2" style="font-size: 11.5px; font-weight: 600">
                <i class="bi bi-patch-check-fill"></i> Email address verified successfully.
              </div>
            </div>

            <!-- <div class="col-md-6">
              <label class="form-label">Tariff <span class="required-star">*</span></label>
              <div class="input-wrapper">
                <i class="bi bi-currency-rupee input-icon"></i>
                <select class="form-select" formControlName="tariff" style="padding-left: 40px">
                  <option value="" disabled selected>Select Tariff</option>
                  <option *ngFor="let t of tariffList" [value]="t.id">{{ t.name }}</option>
                </select>
                <div
                  class="spinner-border spinner-border-sm select-loader"
                  *ngIf="tariffLoading"
                ></div>
              </div>
              <div
                *ngIf="registerForm.get('tariff')?.touched && registerForm.get('tariff')?.invalid"
                class="text-danger"
                style="font-size: 11.5px; margin-top: 4px; font-weight: 500"
              >
                Tariff is required.
              </div>
            </div> -->

            <div class="col-md-6">
              <label class="form-label">GST Number <span class="required-star">*</span></label>
              <div class="input-wrapper">
                <i class="bi bi-receipt input-icon"></i>
                <input type="text" class="form-control text-uppercase" formControlName="gstNumber"
                  placeholder="e.g. 33AABCT1332L1ZB" maxlength="15" />
              </div>
              <div *ngIf="
                  registerForm.get('gstNumber')?.touched && registerForm.get('gstNumber')?.invalid
                " class="text-danger" style="font-size: 11.5px; margin-top: 4px; font-weight: 500">
                <span *ngIf="registerForm.get('gstNumber')?.errors?.['required']">GST number is required.</span>
                <span *ngIf="registerForm.get('gstNumber')?.errors?.['pattern']">Please enter a valid GST format (e.g.
                  33ABCDE1234F1Z5).</span>
              </div>
              <div class="mt-3">
                <div class="mini-upload-card" [class.uploaded]="uploadedFileIds['gstCertificate']"
                  (click)="triggerFileInput('gstCertificate')">
                  <div class="mini-upload-left">
                    <div class="mini-upload-icon">
                      <i class="bi" [class.bi-upload]="!uploadedFileIds['gstCertificate']"
                        [class.bi-file-earmark-check-fill]="uploadedFileIds['gstCertificate']"></i>
                    </div>
                    <div class="mini-upload-text">
                      <div class="mu-title">GST Certificate *</div>
                      <div class="mu-subtitle">
                        {{
                        uploadedFileIds['gstCertificate']
                        ? 'Document attached'
                        : 'Click to upload PDF'
                        }}
                      </div>
                    </div>
                  </div>
                  <div class="mini-upload-right" *ngIf="uploadedFileIds['gstCertificate']">
                    <i class="bi bi-check-circle-fill text-success"></i>
                  </div>
                </div>
                <input type="file" id="fileUpload-gstCertificate" class="d-none" accept=".pdf,.jpg,.jpeg,.png"
                  (change)="onFileSelected($event, 'gstCertificate')" />
              </div>
            </div>

            <div class="col-md-6">
              <label class="form-label">PAN Number <span class="required-star">*</span></label>
              <div class="input-wrapper">
                <i class="bi bi-card-heading input-icon"></i>
                <input type="text" class="form-control text-uppercase" formControlName="panNumber"
                  placeholder="Enter 10-digit PAN" maxlength="10" />
              </div>
              <div *ngIf="
                  registerForm.get('panNumber')?.touched && registerForm.get('panNumber')?.invalid
                " class="text-danger" style="font-size: 11.5px; margin-top: 4px; font-weight: 500">
                <span *ngIf="registerForm.get('panNumber')?.errors?.['required']">PAN number is required.</span>
                <span *ngIf="registerForm.get('panNumber')?.errors?.['pattern']">Please enter a valid PAN format (e.g.
                  ABCDE1234F).</span>
              </div>
              <div class="mt-3">
                <div class="mini-upload-card" [class.uploaded]="uploadedFileIds['panCertificate']"
                  (click)="triggerFileInput('panCertificate')">
                  <div class="mini-upload-left">
                    <div class="mini-upload-icon">
                      <i class="bi" [class.bi-upload]="!uploadedFileIds['panCertificate']"
                        [class.bi-file-earmark-check-fill]="uploadedFileIds['panCertificate']"></i>
                    </div>
                    <div class="mini-upload-text">
                      <div class="mu-title">PAN Certificate *</div>
                      <div class="mu-subtitle">
                        {{
                        uploadedFileIds['panCertificate']
                        ? 'Document attached'
                        : 'Click to upload PDF'
                        }}
                      </div>
                    </div>
                  </div>
                  <div class="mini-upload-right" *ngIf="uploadedFileIds['panCertificate']">
                    <i class="bi bi-check-circle-fill text-success"></i>
                  </div>
                </div>
                <input type="file" id="fileUpload-panCertificate" class="d-none" accept=".pdf,.jpg,.jpeg,.png"
                  (change)="onFileSelected($event, 'panCertificate')" />
              </div>
            </div>

            <div class="col-md-12 mt-2">
              <label class="form-label d-block text-dark fw-semibold mb-2">
                Existence & Capacity Certificate <span class="required-star">*</span>
              </label>
              <div class="mini-upload-card" [class.uploaded]="uploadedFileIds['capacityCertificate']"
                (click)="triggerFileInput('capacityCertificate')">
                <div class="mini-upload-left">
                  <div class="mini-upload-icon">
                    <i class="bi" [class.bi-upload]="!uploadedFileIds['capacityCertificate']"
                      [class.bi-file-earmark-check-fill]="uploadedFileIds['capacityCertificate']"></i>
                  </div>
                  <div class="mini-upload-text">
                    <div class="mu-title">Existence & Capacity Certificate *</div>
                    <div class="mu-subtitle">
                      {{
                      uploadedFileIds['capacityCertificate']
                      ? 'Document attached'
                      : 'Click to upload PDF'
                      }}
                    </div>
                  </div>
                </div>
                <div class="mini-upload-right" *ngIf="uploadedFileIds['capacityCertificate']">
                  <i class="bi bi-check-circle-fill text-success"></i>
                </div>
              </div>
              <input type="file" id="fileUpload-capacityCertificate" class="d-none" accept=".pdf,.jpg,.jpeg,.png"
                (change)="onFileSelected($event, 'capacityCertificate')" />
            </div>

            <!-- <div class="col-md-6">
              <label class="form-label">MSME Type</label>
              <div class="input-wrapper">
                <i class="bi bi-award input-icon"></i>
                <select class="form-select" formControlName="msme" style="padding-left: 40px">
                  <option value="">No MSME / Not Applicable</option>
                  <option value="Micro">Micro Enterprise</option>
                  <option value="Small">Small Enterprise</option>
                  <option value="Medium">Medium Enterprise</option>
                </select>
              </div>
            </div> -->

            <!-- <div class="col-md-6">
              <label class="form-label">TNEB SC No</label>
              <div class="input-wrapper">
                <i class="bi bi-hash input-icon"></i>
                <input
                  type="text"
                  class="form-control"
                  formControlName="tnebScNo"
                  placeholder="Enter TNEB SC Number"
                  maxlength="12"
                />
              </div>
              <div
                *ngIf="
                  registerForm.get('tnebScNo')?.touched && registerForm.get('tnebScNo')?.invalid
                "
                class="text-danger"
                style="font-size: 11.5px; margin-top: 4px; font-weight: 500"
              >
                <span *ngIf="registerForm.get('tnebScNo')?.errors?.['pattern']"
                  >Must be exactly a 12-digit connection number.</span
                >
              </div>
              <div class="mt-3">
                <div
                  class="mini-upload-card"
                  [class.uploaded]="uploadedFileIds['tnebCertificate']"
                  (click)="triggerFileInput('tnebCertificate')"
                >
                  <div class="mini-upload-left">
                    <div class="mini-upload-icon">
                      <i
                        class="bi"
                        [class.bi-upload]="!uploadedFileIds['tnebCertificate']"
                        [class.bi-file-earmark-check-fill]="uploadedFileIds['tnebCertificate']"
                      ></i>
                    </div>
                    <div class="mini-upload-text">
                      <div class="mu-title">TNEB SC Document</div>
                      <div class="mu-subtitle">
                        {{
                          uploadedFileIds['tnebCertificate']
                            ? 'Document attached'
                            : 'Click to upload PDF'
                        }}
                      </div>
                    </div>
                  </div>
                  <div class="mini-upload-right" *ngIf="uploadedFileIds['tnebCertificate']">
                    <i class="bi bi-check-circle-fill text-success"></i>
                  </div>
                </div>
                <input
                  type="file"
                  id="fileUpload-tnebCertificate"
                  class="d-none"
                  accept=".pdf,.jpg,.jpeg,.png"
                  (change)="onFileSelected($event, 'tnebCertificate')"
                />
              </div>
            </div> -->

            <!-- <div class="col-md-12">
              <label class="form-label"
                >TNPCB - CTO CERTIFICATE <span class="required-star">*</span></label
              >
              <div class="input-wrapper">
                <i class="bi bi-clipboard-check input-icon"></i>
                <select
                  class="form-select"
                  formControlName="consentToOperate"
                  style="padding-left: 40px"
                >
                  <option value="" disabled selected>Select CTO Category</option>
                  <option value="Exempted">Exempted</option>
                  <option value="Not-Exempted">Not-Exempted</option>
                </select>
              </div>
              <div
                *ngIf="
                  registerForm.get('consentToOperate')?.touched &&
                  registerForm.get('consentToOperate')?.invalid
                "
                class="text-danger"
                style="font-size: 11.5px; margin-top: 4px; font-weight: 500"
              >
                TNPCB CTO Certificate is required.
              </div>
            </div> -->
          </div>

          <div class="form-navigation mt-4 pt-3 border-top d-flex justify-content-between align-items-center">
            <button type="button" class="btn-back" (click)="prevStep()">
              <i class="bi bi-arrow-left"></i> Back
            </button>
            <div class="d-flex gap-2">
              <button type="button" class="btn-save-draft" (click)="onSaveDraft()"
                [disabled]="isSavingDraft || !canSaveDraft()">
                <span *ngIf="isSavingDraft" class="spinner-border spinner-border-sm me-1" role="status"
                  aria-hidden="true"></span>
                <i *ngIf="!isSavingDraft" class="bi bi-save2"></i>
                {{ isSavingDraft ? 'Saving...' : 'Save Draft' }}
              </button>
              <button type="button" class="btn-next" (click)="nextStep()">
                Next Step<i class="bi bi-arrow-right"></i>
              </button>
            </div>
          </div>
        </div>

        <!-- ===== STEP 3: Address Info ===== -->
        <div class="form-step" *ngIf="activeStep === 2">
          <div class="section-title d-flex align-items-center gap-2 mb-4">
            <i class="bi bi-geo-alt-fill"></i>
            <h3 class="mb-0 fw-semibold text-uppercase">Trader Address</h3>
          </div>
          <p class="section-desc">Enter the physical address of your trading company.</p>

          <div class="row g-3">
            <div class="col-md-4">
              <label class="form-label">Door No <span class="required-star">*</span></label>
              <div class="input-wrapper">
                <i class="bi bi-house input-icon"></i>
                <input type="text" class="form-control" formControlName="doorNo" placeholder="e.g. 15A" />
              </div>
              <div *ngIf="registerForm.get('doorNo')?.touched && registerForm.get('doorNo')?.invalid"
                class="text-danger" style="font-size: 11.5px; margin-top: 4px; font-weight: 500">
                Door number is required.
              </div>
            </div>

            <div class="col-md-4">
              <label class="form-label">Survey Field No <span class="required-star">*</span></label>
              <div class="input-wrapper">
                <i class="bi bi-hash input-icon"></i>
                <input type="text" class="form-control" formControlName="surveyFieldNo" placeholder="e.g. 12" />
              </div>
              <div *ngIf="
                  registerForm.get('surveyFieldNo')?.touched &&
                  registerForm.get('surveyFieldNo')?.invalid
                " class="text-danger" style="font-size: 11.5px; margin-top: 4px; font-weight: 500">
                Survey field number is required.
              </div>
            </div>

            <div class="col-md-4">
              <label class="form-label">Street / Location <span class="required-star">*</span></label>
              <div class="input-wrapper">
                <i class="bi bi-signpost-split input-icon"></i>
                <input type="text" class="form-control" formControlName="street"
                  placeholder="Enter street, area, landmark" />
              </div>
              <div *ngIf="registerForm.get('street')?.touched && registerForm.get('street')?.invalid"
                class="text-danger" style="font-size: 11.5px; margin-top: 4px; font-weight: 500">
                Street is required.
              </div>
            </div>

            <div class="col-md-4">
              <label class="form-label">State <span class="required-star">*</span></label>
              <div class="input-wrapper">
                <i class="bi bi-globe input-icon"></i>
                <select class="form-select" formControlName="state" style="padding-left: 40px">
                  <!-- <option value="">Select State</option> -->
                  <option *ngFor="let s of states" [value]="s.id">{{ s.name }}</option>
                </select>
                <div class="spinner-border spinner-border-sm select-loader" *ngIf="statesLoading"></div>
              </div>
              <div *ngIf="registerForm.get('state')?.touched && registerForm.get('state')?.invalid" class="text-danger"
                style="font-size: 11.5px; margin-top: 4px; font-weight: 500">
                State is required.
              </div>
            </div>

            <div class="col-md-4">
              <label class="form-label">District <span class="required-star">*</span></label>
              <div class="input-wrapper">
                <i class="bi bi-map input-icon"></i>
                <select class="form-select" formControlName="districtId" style="padding-left: 40px"
                  [disabled]="!registerForm.get('state')?.value">
                  <option value="">Select District</option>
                  <option *ngFor="let d of districts" [value]="d.id">{{ d.name }}</option>
                </select>
                <div class="spinner-border spinner-border-sm select-loader" *ngIf="districtsLoading"></div>
              </div>
              <div *ngIf="
                  registerForm.get('districtId')?.touched && registerForm.get('districtId')?.invalid
                " class="text-danger" style="font-size: 11.5px; margin-top: 4px; font-weight: 500">
                District is required.
              </div>
            </div>

            <div class="col-md-4">
              <label class="form-label">Taluk <span class="required-star">*</span></label>
              <div class="input-wrapper">
                <i class="bi bi-geo-alt input-icon"></i>
                <select class="form-select" formControlName="talukId" style="padding-left: 40px"
                  [disabled]="!registerForm.get('districtId')?.value">
                  <option value="">Select Taluk</option>
                  <option *ngFor="let t of taluks" [value]="t.id">{{ t.name }}</option>
                </select>
                <div class="spinner-border spinner-border-sm select-loader" *ngIf="taluksLoading"></div>
              </div>
              <div *ngIf="registerForm.get('talukId')?.touched && registerForm.get('talukId')?.invalid"
                class="text-danger" style="font-size: 11.5px; margin-top: 4px; font-weight: 500">
                Taluk is required.
              </div>
            </div>

            <div class="col-md-4">
              <label class="form-label">Village <span class="required-star">*</span></label>
              <div class="input-wrapper">
                <i class="bi bi-geo-alt input-icon"></i>
                <select class="form-select" formControlName="villageId" style="padding-left: 40px"
                  [disabled]="!registerForm.get('talukId')?.value">
                  <option value="">Select Village</option>
                  <option *ngFor="let v of villages" [value]="v.id">{{ v.name }}</option>
                </select>
                <div class="spinner-border spinner-border-sm select-loader" *ngIf="villagesLoading"></div>
              </div>
              <div *ngIf="
                  registerForm.get('villageId')?.touched && registerForm.get('villageId')?.invalid
                " class="text-danger" style="font-size: 11.5px; margin-top: 4px; font-weight: 500">
                Village is required.
              </div>
            </div>

            <div class="col-md-6 col-lg-4">
              <div class="form-group premium-field">
                <label class="form-label d-inline-flex align-items-center">
                  Pincode<span class="text-danger ms-1">*</span>
                </label>
                <div class="input-wrapper">
                  <i class="bi bi-pin-angle input-icon"></i>
                  <input type="text" class="form-control" formControlName="pincode" placeholder="Enter 6-digit pincode"
                    maxlength="6" onkeypress="return event.charCode >= 48 && event.charCode <= 57;" />
                </div>
                <div *ngIf="
                    registerForm.get('pincode')?.touched && registerForm.get('pincode')?.invalid
                  " class="text-danger" style="font-size: 11.5px; margin-top: 4px; font-weight: 500">
                  <span *ngIf="registerForm.get('pincode')?.errors?.['required']">Pincode is required.</span>
                  <span *ngIf="registerForm.get('pincode')?.errors?.['pattern']">Enter a valid 6-digit pincode.</span>
                </div>
              </div>
            </div>

            <div class="col-md-6 col-lg-4">
              <div class="form-group premium-field">
                <label class="form-label d-inline-flex align-items-center"> Latitude </label>
                <div class="input-wrapper">
                  <i class="bi bi-geo-alt input-icon"></i>
                  <input type="text" class="form-control" formControlName="latitude"
                    placeholder="Select location on map" readonly />
                </div>
                <div *ngIf="
                    registerForm.get('latitude')?.touched && registerForm.get('latitude')?.invalid
                  " class="text-danger" style="font-size: 11.5px; margin-top: 4px; font-weight: 500">
                  <span *ngIf="registerForm.get('latitude')?.errors?.['pattern']">Enter a valid latitude.</span>
                </div>
              </div>
            </div>

            <div class="col-md-6 col-lg-4">
              <div class="form-group premium-field">
                <label class="form-label d-inline-flex align-items-center"> Longitude </label>
                <div class="input-wrapper">
                  <i class="bi bi-geo-alt-fill input-icon"></i>
                  <input type="text" class="form-control" formControlName="longitude"
                    placeholder="Select location on map" readonly />
                </div>
                <div *ngIf="
                    registerForm.get('longitude')?.touched && registerForm.get('longitude')?.invalid
                  " class="text-danger" style="font-size: 11.5px; margin-top: 4px; font-weight: 500">
                  <span *ngIf="registerForm.get('longitude')?.errors?.['pattern']">Enter a valid longitude.</span>
                </div>
              </div>
            </div>
          </div>

          <div class="location-map-section mb-3 mt-3">
            <label class="form-label d-flex align-items-center gap-2 mb-1">
              <i class="bi bi-map"></i> Select Location on Map
            </label>
            <p class="map-selection-hint">
              Search for a location, click on the map to place a marker, or drag the marker to
              adjust. Latitude and longitude will be filled automatically.
            </p>
            <div class="input-wrapper location-search-wrapper mb-2">
              <i class="bi bi-search input-icon"></i>
              <input #locationSearch type="text" class="form-control location-search-input"
                placeholder="Search for a location or address" autocomplete="off" />
            </div>
            <div #locationMapContainer class="location-map-container" role="application" aria-label="Location map">
            </div>
            <div *ngIf="locationMapError" class="text-danger"
              style="font-size: 11.5px; margin-top: 8px; font-weight: 500">
              {{ locationMapError }}
            </div>
          </div>

          <button type="button" class="btn-gps mt-2 mb-4" (click)="detectLocation()">
            <i class="bi bi-geo-alt-fill"></i> Auto-Detect Coordinates (GPS)
          </button>

          <div class="form-navigation mt-4 pt-3 border-top d-flex justify-content-between align-items-center">
            <button type="button" class="btn-back" (click)="prevStep()">
              <i class="bi bi-arrow-left"></i> Back
            </button>
            <div class="d-flex gap-2">
              <button type="button" class="btn-save-draft" (click)="onSaveDraft()"
                [disabled]="isSavingDraft || !canSaveDraft()">
                <span *ngIf="isSavingDraft" class="spinner-border spinner-border-sm me-1" role="status"
                  aria-hidden="true"></span>
                <i *ngIf="!isSavingDraft" class="bi bi-save2"></i>
                {{ isSavingDraft ? 'Saving...' : 'Save Draft' }}
              </button>
              <button type="button" class="btn-next" (click)="nextStep()">
                Next Step<i class="bi bi-arrow-right"></i>
              </button>
            </div>
          </div>
        </div>

        <!-- ===== STEP 4: Operations ===== -->
        <div class="form-step" *ngIf="activeStep === 3">
          <div class="section-title d-flex align-items-center gap-2 mb-4">
            <i class="bi bi-gear-wide-connected"></i>
            <h3 class="mb-0 fw-semibold text-uppercase">Operations</h3>
          </div>
          <p class="section-desc">Provide ash operations details.</p>

          <!-- Operations Section -->
          <!-- <div class="sub-section-header mb-3"><i class="bi bi-stack"></i> Ash Operations</div> -->

          <div class="row g-3">
            <!-- <div class="col-md-6">
              <label class="form-label"
                >Plant Machinery Availability <span class="required-star">*</span></label
              >
              <div class="input-wrapper">
                <i class="bi bi-tools input-icon"></i>
                <input
                  type="text"
                  class="form-control"
                  formControlName="plantMachineriesAvailability"
                  placeholder="Describe available plant machinery"
                />
              </div>
              <div
                *ngIf="
                  registerForm.get('plantMachineriesAvailability')?.touched &&
                  registerForm.get('plantMachineriesAvailability')?.invalid
                "
                class="text-danger"
                style="font-size: 11.5px; margin-top: 4px; font-weight: 500"
              >
                This field is required.
              </div>
            </div> -->

            <div class="col-md-6">
              <label class="form-label">Capacity (MT/Day) <span class="required-star">*</span></label>
              <div class="input-wrapper">
                <i class="bi bi-speedometer2 input-icon"></i>
                <select class="form-select" formControlName="capacity" style="padding-left: 40px">
                  <option value="" disabled selected>Select Capacity</option>
                  <option value="16">16 MT</option>
                  <option value="22">22 MT</option>
                  <option value="28">28 MT</option>
                  <option value="29">29 MT</option>
                  <option value="40">40 MT</option>
                </select>
              </div>
              <div *ngIf="
                  registerForm.get('capacity')?.touched && registerForm.get('capacity')?.invalid
                " class="text-danger" style="font-size: 11.5px; margin-top: 4px; font-weight: 500">
                Capacity is required and must be greater than 0.
              </div>
            </div>

            <!-- <div class="col-md-6">
              <label class="form-label">Required Quantity of Ash (MT)</label>
              <div class="input-wrapper">
                <i class="bi bi-box-seam input-icon"></i>
                <input
                  type="number"
                  class="form-control"
                  formControlName="requiredQuantityOfAsh"
                  placeholder="e.g. 250.50"
                  min="0"
                  step="0.01"
                />
              </div>
            </div> -->

            <!-- Ash Unloading Facility Multi-Select -->
            <!-- <div class="col-md-6">
              <label class="form-label">Ash Unloading Facility</label>
              <div class="multi-select-wrapper" (click)="$event.stopPropagation()">
                <div
                  class="multi-select-trigger"
                  (click)="
                    showUnloadDropdown = !showUnloadDropdown;
                    showCategoryDropdown = false
                  "
                >
                  <span *ngIf="selectedUnloadIds.length === 0" class="multi-select-placeholder"
                    >Select unloading facilities...</span
                  >
                  <div class="multi-select-tags" *ngIf="selectedUnloadIds.length > 0">
                    <span class="tag" *ngFor="let id of selectedUnloadIds">
                      {{ getUnloadName(id) }}
                      <i
                        class="bi bi-x tag-remove"
                        (click)="$event.stopPropagation(); removeUnload(id)"
                      ></i>
                    </span>
                  </div>
                  <i class="bi bi-chevron-down ms-auto"></i>
                </div>
                <div class="multi-select-dropdown" *ngIf="showUnloadDropdown">
                  <div
                    class="multi-select-option"
                    *ngFor="let u of ashUnloadList"
                    [class.selected]="isUnloadSelected(u.id)"
                    (click)="toggleUnload(u, $event)"
                  >
                    <i
                      class="bi"
                      [class.bi-check-square-fill]="isUnloadSelected(u.id)"
                      [class.bi-square]="!isUnloadSelected(u.id)"
                    ></i>
                    {{ u.name }}
                  </div>
                  <div *ngIf="ashUnloadList.length === 0" class="p-3 text-muted text-center small">
                    <span *ngIf="unloadLoading"
                      ><span class="spinner-border spinner-border-sm me-1"></span> Loading...</span
                    >
                    <span *ngIf="!unloadLoading">No facilities available</span>
                  </div>
                </div>
              </div>
            </div> -->
            <!-- Ash Categories Table (matching manufacturing register) -->
            <div class="col-md-12">
              <label class="form-label" style="text-transform: uppercase; font-weight: bold">ASH CATEGORY <span
                  class="required-star">*</span></label>

              <div class="table-responsive border rounded bg-white">
                <table class="table table-borderless mb-0 align-middle">
                  <thead class="bg-light">
                    <tr>
                      <th scope="col" style="
                          width: 50%;
                          font-size: 12px;
                          font-weight: 600;
                          color: #495057;
                          border-bottom: 1px solid #dee2e6;
                          padding: 10px 16px;
                        ">
                        ASH CATEGORY
                      </th>
                      <th scope="col" style="
                          width: 50%;
                          font-size: 12px;
                          font-weight: 600;
                          color: #495057;
                          border-bottom: 1px solid #dee2e6;
                          padding: 10px 16px;
                        ">
                        Min & Max Load<br />(No. of<br />loads/Quarterly)
                        <div style="
                            color: rgb(122, 204, 28);
                            font-size: 9px;
                            font-weight: 400;
                            margin-top: 2px;
                          ">
                          Issue of the ash is subject to availability
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let cat of ashCategories">
                      <td style="padding: 10px 16px; border-bottom: 1px solid #f1f3f5">
                        <div class="form-check d-flex align-items-center mb-0">
                          <input class="form-check-input mt-0 me-2" type="checkbox" [id]="'cat_' + cat.id"
                            [checked]="isAshCategoryChecked(cat.id)" (change)="toggleAshCategory(cat.id)"
                            style="cursor: pointer; width: 18px; height: 18px" />
                          <label class="form-check-label text-secondary mb-0" [for]="'cat_' + cat.id" style="
                              font-size: 13.5px;
                              font-weight: 500;
                              cursor: pointer;
                              padding-left: 4px;
                            ">
                            {{ cat.name }}
                          </label>
                        </div>
                      </td>
                      <td style="padding: 6px 16px; border-bottom: 1px solid #f1f3f5">
                        <ng-container *ngIf="isAshCategoryChecked(cat.id)">
                          <ng-container *ngIf="getCategoryFormGroup(cat.id) as catGroup">
                            <div [formGroup]="catGroup" class="d-flex flex-column gap-2">
                              <div class="d-flex gap-2">
                                <div class="flex-grow-1">
                                  <input type="number" class="form-control" formControlName="minLoad" oninput="
                                      if (this.value.length > 4)
                                        this.value = this.value.slice(0, 4);
                                    " style="
                                      background-color: #f8f9fa;
                                      height: 36px;
                                      font-size: 13.5px;
                                      padding: 0 10px;
                                    " placeholder="min 1-10" />
                                  <div class="mt-1" style="font-size: 10px; color: #6c757d; font-weight: 500" *ngIf="
                                      catGroup.get('minLoad')?.value &&
                                      registerForm.get('capacity')?.value
                                    ">
                                    Qty:
                                    {{
                                    (catGroup.get('minLoad')?.value || 0) *
                                    (registerForm.get('capacity')?.value || 0)
                                    }}
                                    MT
                                  </div>
                                </div>
                                <div class="flex-grow-1">
                                  <input type="number" class="form-control" formControlName="maxLoad" oninput="
                                      if (this.value.length > 4)
                                        this.value = this.value.slice(0, 4);
                                    " style="
                                      background-color: #f8f9fa;
                                      height: 36px;
                                      font-size: 13.5px;
                                      padding: 0 10px;
                                    " placeholder="max 10-20" />
                                  <div class="mt-1" style="font-size: 10px; color: #6c757d; font-weight: 500" *ngIf="
                                      catGroup.get('maxLoad')?.value &&
                                      registerForm.get('capacity')?.value
                                    ">
                                    Qty:
                                    {{
                                    (catGroup.get('maxLoad')?.value || 0) *
                                    (registerForm.get('capacity')?.value || 0)
                                    }}
                                    MT
                                  </div>
                                </div>
                              </div>
                              <div *ngIf="catGroup.touched && catGroup.invalid" class="text-danger mt-1"
                                style="font-size: 11.5px; font-weight: 500; line-height: 1.2">
                                <span *ngIf="catGroup.get('minLoad')?.errors?.['required']">Min Load is
                                  required.<br /></span>
                                <span *ngIf="catGroup.get('maxLoad')?.errors?.['required']">Max Load is
                                  required.<br /></span>
                                <span *ngIf="catGroup.get('minLoad')?.errors?.['min']">Minimum Load must be at least
                                  1.<br /></span>
                                <span *ngIf="catGroup.get('maxLoad')?.errors?.['min']">Maximum Load must be at least
                                  1.<br /></span>
                                <span *ngIf="catGroup.get('minLoad')?.errors?.['max']">Minimum Load must not exceed
                                  10.<br /></span>
                                <span *ngIf="catGroup.get('maxLoad')?.errors?.['max']">Maximum Load must not exceed
                                  20.<br /></span>
                                <span *ngIf="
                                    catGroup.get('minLoad')?.errors?.['pattern'] ||
                                    catGroup.get('maxLoad')?.errors?.['pattern']
                                  ">Load must be up to 5 digits.<br /></span>
                                <span *ngIf="catGroup.errors?.['minGreaterThanMax']">Minimum Load should not exceed
                                  Maximum Load.</span>
                              </div>
                            </div>
                          </ng-container>
                        </ng-container>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div *ngIf="!ashCategories || ashCategories.length === 0" class="text-muted mt-2"
                style="font-size: 13.5px">
                Please select a Power Station to view ash categories.
              </div>
              <div *ngIf="
                  registerForm.get('ashCategoryDetails')?.touched &&
                  registerForm.get('ashCategoryDetails')?.invalid
                " class="text-danger mt-2" style="font-size: 11.5px; margin-top: 4px; font-weight: 500">
                At least one ash category must be selected and quantities must be valid.
              </div>
            </div>
          </div>

          <div class="form-navigation mt-4 pt-3 border-top d-flex justify-content-between align-items-center">
            <button type="button" class="btn-back" (click)="prevStep()">
              <i class="bi bi-arrow-left"></i> Back
            </button>
            <div class="d-flex gap-2">
              <button type="button" class="btn-save-draft" (click)="onSaveDraft()"
                [disabled]="isSavingDraft || !canSaveDraft()">
                <span *ngIf="isSavingDraft" class="spinner-border spinner-border-sm me-1" role="status"
                  aria-hidden="true"></span>
                <i *ngIf="!isSavingDraft" class="bi bi-save2"></i>
                {{ isSavingDraft ? 'Saving...' : 'Save Draft' }}
              </button>
              <button type="button" class="btn-next" (click)="nextStep()">
                Next Step<i class="bi bi-arrow-right"></i>
              </button>
            </div>
          </div>
        </div>

        <!-- ===== STEP 5: Users ===== -->
        <div class="form-step" *ngIf="activeStep === 4">
          <div class="section-title d-flex align-items-center gap-2 mb-4">
            <i class="bi bi-people-fill"></i>
            <h3 class="mb-0 fw-semibold text-uppercase">Users</h3>
          </div>
          <p class="section-desc mb-3">
            Add the vendors who will trade with you. You can add multiple vendors.
          </p>

          <div formArrayName="vendors">
            <div *ngFor="let vendor of vendors.controls; let i = index" [formGroupName]="i" class="vendor-card mb-3">
              <div class="vendor-card-header d-flex justify-content-between align-items-center">
                <span class="fw-semibold text-primary">
                  <i class="bi bi-building me-2"></i>Vendor {{ i + 1 }}
                </span>

                <button type="button" class="btn btn-sm btn-outline-danger" (click)="removeVendor(i)"
                  *ngIf="vendors.length > 1">
                  <i class="bi bi-trash"></i> Remove
                </button>
              </div>

              <div class="row g-3 mt-1">
                <!-- Vendor Name -->
                <div class="col-md-6">
                  <label class="form-label">
                    Vendor Name <span class="required-star">*</span>
                  </label>

                  <div class="input-wrapper">
                    <i class="bi bi-building input-icon"></i>
                    <input type="text" class="form-control" formControlName="vendorName"
                      placeholder="Enter Vendor Name" />
                  </div>

                  <div *ngIf="vendor.get('vendorName')?.touched && vendor.get('vendorName')?.invalid"
                    class="text-danger" style="font-size: 11.5px; margin-top: 4px; font-weight: 500">
                    Vendor name is required.
                  </div>
                </div>

                <!-- Purpose -->
                <div class="col-md-6">
                  <label class="form-label"> Purpose <span class="required-star">*</span> </label>

                  <div class="input-wrapper">
                    <i class="bi bi-clipboard-check input-icon"></i>
                    <input type="text" class="form-control" formControlName="purpose" placeholder="Enter Purpose" />
                  </div>

                  <div *ngIf="vendor.get('purpose')?.touched && vendor.get('purpose')?.invalid" class="text-danger"
                    style="font-size: 11.5px; margin-top: 4px; font-weight: 500">
                    Purpose is required.
                  </div>
                </div>

                <!-- Mobile Number -->
                <div class="col-md-6">
                  <label class="form-label">
                    Mobile Number <span class="required-star">*</span>
                  </label>

                  <div class="input-wrapper d-flex align-items-center gap-2"
                    style="background: transparent; border: none; padding: 0">
                    <div class="position-relative flex-grow-1"
                      style="background: #fff; border: 1px solid #dee2e6; border-radius: 8px">
                      <i class="bi bi-telephone input-icon"></i>
                      <input type="text" class="form-control" formControlName="mobileNo" maxlength="10"
                        placeholder="Enter Mobile Number" (blur)="onVendorMobileBlur(i)" style="border: none" />
                    </div>
                    <button type="button"
                      class="btn btn-sm px-3 shadow-sm d-flex align-items-center justify-content-center gap-1"
                      [class.btn-success]="verifiedVendorMobiles.has(vendor.get('mobileNo')?.value)"
                      [class.btn-outline-primary]="
                        !verifiedVendorMobiles.has(vendor.get('mobileNo')?.value)
                      " (click)="
                        !verifiedVendorMobiles.has(vendor.get('mobileNo')?.value)
                          ? onVendorMobileBlur(i)
                          : null
                      " [disabled]="
                        !vendor.get('mobileNo')?.valid ||
                        verifiedVendorMobiles.has(vendor.get('mobileNo')?.value)
                      " style="
                        height: 44px;
                        white-space: nowrap;
                        border-radius: 8px;
                        font-weight: 500;
                      ">
                      <i class="bi" [class.bi-check-circle-fill]="
                          verifiedVendorMobiles.has(vendor.get('mobileNo')?.value)
                        " [class.bi-shield-check]="
                          !verifiedVendorMobiles.has(vendor.get('mobileNo')?.value)
                        "></i>
                      {{
                      verifiedVendorMobiles.has(vendor.get('mobileNo')?.value)
                      ? 'Verified'
                      : 'Verify'
                      }}
                    </button>
                  </div>

                  <div *ngIf="vendor.get('mobileNo')?.touched && vendor.get('mobileNo')?.invalid" class="text-danger"
                    style="font-size: 11.5px; margin-top: 4px; font-weight: 500">
                    Valid mobile number is required.
                  </div>
                </div>

                <!-- Email -->
                <div class="col-md-6">
                  <label class="form-label"> Email(Optional) </label>

                  <div class="input-wrapper">
                    <i class="bi bi-envelope input-icon"></i>
                    <input type="email" class="form-control" formControlName="email"
                      placeholder="Enter Email Address" />
                  </div>

                  <div *ngIf="vendor.get('email')?.touched && vendor.get('email')?.invalid" class="text-danger"
                    style="font-size: 11.5px; margin-top: 4px; font-weight: 500">
                    Please enter a valid email address.
                  </div>
                </div>

                <!-- Delivery Address -->
                <div class="col-md-6">
                  Delivery Address <span class="required-star">*</span>
                  <label class="form-label">
                  </label>

                  <div class="input-wrapper textarea-wrapper">
                    <i class="bi bi-geo-alt input-icon"></i>
                    <textarea type="text" class="form-control" formControlName="deliveryAddress"
                      placeholder="Enter Delivery Address"></textarea>
                  </div>

                  <div *ngIf="
                      vendor.get('deliveryAddress')?.touched &&
                      vendor.get('deliveryAddress')?.invalid
                    " class="text-danger" style="font-size: 11.5px; margin-top: 4px; font-weight: 500">
                    Delivery address is required.
                  </div>
                </div>
              </div>
            </div>
          </div>

          <button type="button" class="btn-add-vendor mt-2" (click)="addVendor()">
            <i class="bi bi-plus-circle-fill me-2"></i> Add Vendor
          </button>

          <div class="form-navigation mt-4 pt-3 border-top d-flex justify-content-between align-items-center">
            <button type="button" class="btn-back" (click)="prevStep()">
              <i class="bi bi-arrow-left"></i> Back
            </button>
            <button type="button" class="btn-next" (click)="nextStep()">
              Next Step<i class="bi bi-arrow-right"></i>
            </button>
          </div>
        </div>

        <!-- ===== STEP 6: Upload Documents ===== -->
        <div class="form-step" *ngIf="activeStep === 5">
          <div class="section-title d-flex align-items-center gap-2 mb-4">
            <i class="bi bi-file-earmark-arrow-up-fill"></i>
            <h3 class="mb-0 fw-semibold text-uppercase">Upload Documents</h3>
          </div>
          <p class="section-desc">
            Upload the required supporting documents. Accepted formats: PDF, JPG, PNG.
          </p>

          <div class="row g-3">
            <div class="col-md-6" *ngFor="
                let docKey of ['tradeLicence', 'leaseDeed', 'propertyTax', 'installationPermission']
              ">
              <div class="mini-upload-card" [class.uploaded]="uploadedFileIds[docKey]"
                (click)="!uploadedFileIds[docKey] && triggerFileInput(docKey)"
                style="cursor: pointer; position: relative">
                <div class="mini-upload-left">
                  <div class="mini-upload-icon">
                    <i class="bi" [class.bi-file-earmark-check-fill]="uploadedFileIds[docKey]"
                      [class.bi-cloud-arrow-up-fill]="!uploadedFileIds[docKey]"></i>
                  </div>
                  <div class="mini-upload-info">
                    <div class="mini-upload-title">
                      {{ docLabels[docKey] }}
                      <span class="required-star">*</span>
                    </div>
                    <div class="mini-upload-hint" [class.success]="uploadedFileIds[docKey]">
                      <span *ngIf="uploadedFileIds[docKey]"> Uploaded successfully </span>
                      <span *ngIf="!uploadedFileIds[docKey]">PDF, Image (Max 2MB)</span>
                    </div>
                  </div>
                </div>

                <div class="d-flex align-items-center me-3" style="z-index: 2" *ngIf="uploadedFileIds[docKey]">
                  <button type="button" class="btn btn-sm btn-light text-primary me-2 shadow-sm border"
                    (click)="$event.stopPropagation(); viewDocument(docKey)" title="Preview" style="
                      width: 32px;
                      height: 32px;
                      padding: 0;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      border-radius: 6px;
                    ">
                    <i class="bi bi-eye"></i>
                  </button>
                  <button type="button" class="btn btn-sm btn-light text-danger shadow-sm border"
                    (click)="$event.stopPropagation(); deleteDocument(docKey)" title="Delete" style="
                      width: 32px;
                      height: 32px;
                      padding: 0;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      border-radius: 6px;
                    ">
                    <i class="bi bi-trash"></i>
                  </button>
                </div>

                <div class="me-3" *ngIf="isUploading && activeUploadDocKey === docKey">
                  <span class="spinner-border spinner-border-sm text-primary"></span>
                </div>
                <i *ngIf="
                    !uploadedFileIds[docKey] && !(isUploading && activeUploadDocKey === docKey)
                  " class="bi mini-upload-status bi-chevron-right"></i>
                <input type="file" [id]="'fileUpload-' + docKey" class="d-none" accept=".pdf,.jpg,.jpeg,.png"
                  (change)="onFileSelected($event, docKey)" />
              </div>
            </div>
          </div>

          <div class="form-navigation mt-4 pt-3 border-top d-flex justify-content-between align-items-center">
            <button type="button" class="btn-back" (click)="prevStep()">
              <i class="bi bi-arrow-left"></i> Back
            </button>
            <div class="d-flex gap-2">
              <button type="button" class="btn-save-draft" (click)="onSaveDraft()"
                [disabled]="isSavingDraft || !canSaveDraft()">
                <span *ngIf="isSavingDraft" class="spinner-border spinner-border-sm me-1" role="status"
                  aria-hidden="true"></span>
                <i *ngIf="!isSavingDraft" class="bi bi-save2"></i>
                {{ isSavingDraft ? 'Saving...' : 'Save Draft' }}
              </button>
              <button type="button" class="btn-next" (click)="nextStep()">
                Next Step<i class="bi bi-arrow-right"></i>
              </button>
            </div>
          </div>
        </div>

        <!-- ===== STEP 7: Preview Application ===== -->
        <div class="form-step" *ngIf="activeStep === 6">
          <div class="section-title d-flex align-items-center gap-2 mb-4">
            <i class="bi bi-clipboard2-check-fill"></i>
            <h3 class="mb-0 fw-semibold text-uppercase">Preview Application</h3>
          </div>
          <p class="section-desc">Review all your details before final submission.</p>

          <div class="preview-layout">
            <!-- Section 1: Station and Type -->
            <div class="preview-section mb-4">
              <h4 class="preview-section-title">
                <i class="bi bi-house-door-fill me-2"></i>Station & Source Info
              </h4>
              <div class="row g-3">
                <div class="col-md-6">
                  <div class="preview-label">Power Station</div>
                  <div class="preview-value">{{ getPowerStationName() }}</div>
                </div>
                <div class="col-md-6">
                  <div class="preview-label">Mobile Number</div>
                  <div class="preview-value">+91 {{ registerForm.get('mobileNumber')?.value }}</div>
                </div>
              </div>
            </div>

            <!-- Section 2: Firm Details -->
            <div class="preview-section mb-4">
              <h4 class="preview-section-title">
                <i class="bi bi-building me-2"></i>Trader Details
              </h4>
              <div class="row g-3">
                <div class="col-md-6">
                  <div class="preview-label">Firm Name</div>
                  <div class="preview-value fw-semibold">
                    {{ registerForm.get('firmName')?.value }}
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="preview-label">Email ID</div>
                  <div class="preview-value">{{ registerForm.get('email')?.value }}</div>
                </div>
                <div class="col-md-6">
                  <div class="preview-label">GST Number</div>
                  <div class="preview-value mono">
                    {{ registerForm.get('gstNumber')?.value | uppercase }}
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="preview-label">PAN Number</div>
                  <div class="preview-value mono">
                    {{ registerForm.get('panNumber')?.value | uppercase }}
                  </div>
                </div>
                <!-- <div class="col-md-6">
                  <div class="preview-label">TNEB Service Connection Number</div>
                  <div class="preview-value mono">
                    {{ registerForm.get('tnebScNo')?.value || '-' }}
                  </div>
                </div> -->
              </div>
            </div>

            <!-- Section 3: Address Info -->
            <div class="preview-section mb-4">
              <h4 class="preview-section-title">
                <i class="bi bi-geo-alt-fill me-2"></i>Trader Address
              </h4>
              <div class="row g-3">
                <div class="col-md-12">
                  <div class="preview-label">Physical Address</div>
                  <div class="preview-value">
                    Door No. {{ registerForm.get('doorNo')?.value }}, Survey Field No.
                    {{ registerForm.get('surveyFieldNo')?.value }},<br />
                    {{ registerForm.get('street')?.value }}, {{ getVillageName() }},{{
                    getTalukName()
                    }},<br />
                    {{ getDistrictName() }}, {{ getStateName() }} -
                    {{ registerForm.get('pincode')?.value }}
                  </div>
                </div>
              </div>

              <div class="row g-3 mt-1" *ngIf="registerForm.get('latitude')?.value">
                <div class="col-12">
                  <div class="preview-map-section mt-1">
                    <div #previewMapContainer class="location-map-container preview-location-map" role="img"
                      aria-label="Location preview map"></div>
                  </div>
                  <div *ngIf="previewMapError" class="text-danger mt-2" style="font-size: 11.5px; font-weight: 500">
                    {{ previewMapError }}
                  </div>
                </div>
              </div>
            </div>

            <!-- Section 4: Plant Operations -->
            <div class="preview-section mb-4">
              <h4 class="preview-section-title">
                <i class="bi bi-gear-wide-connected me-2"></i>Operations & Capacity
              </h4>
              <div class="row g-3">
                <div class="col-md-6">
                  <div class="preview-label">Capacity (MT/Day)</div>
                  <div class="preview-value">
                    {{ registerForm.get('capacity')?.value || '-' }} MT
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="preview-label">Required Ash Qty (MT)</div>
                  <div class="preview-value">
                    {{ registerForm.get('requiredQuantityOfAsh')?.value || '-' }}
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="preview-label mb-2">Requested Ash Categories & Quantities</div>
                  <div class="table-responsive border rounded" *ngIf="ashCategoryDetails.length > 0">
                    <table class="table table-sm table-striped mb-0 align-middle">
                      <thead class="bg-light">
                        <tr>
                          <th class="ps-3 py-2" style="font-size: 12px">Ash Category</th>
                          <th class="py-2 text-center" style="font-size: 12px">Min Load</th>
                          <th class="py-2 text-center" style="font-size: 12px">Max Load</th>
                          <th class="py-2 text-center" style="font-size: 12px">
                            Min Quantity (MT)
                          </th>
                          <th class="pe-3 py-2 text-center" style="font-size: 12px">
                            Max Quantity (MT)
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let ctrl of ashCategoryDetails.controls">
                          <td class="ps-3 py-2 fw-medium" style="font-size: 13px">
                            {{ getCategoryName(ctrl.value.categoryId) }}
                          </td>
                          <td class="py-2 text-center" style="font-size: 13px">
                            {{ ctrl.value.minLoad || '-' }}
                          </td>
                          <td class="py-2 text-center" style="font-size: 13px">
                            {{ ctrl.value.maxLoad || '-' }}
                          </td>
                          <td class="py-2 text-center" style="font-size: 13px">
                            {{
                            ctrl.value.minLoad
                            ? ctrl.value.minLoad * (registerForm.get('capacity')?.value || 0)
                            : '-'
                            }}
                          </td>
                          <td class="pe-3 py-2 text-center" style="font-size: 13px">
                            {{
                            ctrl.value.maxLoad
                            ? ctrl.value.maxLoad * (registerForm.get('capacity')?.value || 0)
                            : '-'
                            }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div *ngIf="ashCategoryDetails.length === 0" class="text-muted small">-</div>
                </div>
              </div>
            </div>

            <!-- Section 5: Vendors -->
            <div class="preview-section mb-4">
              <h4 class="preview-section-title"><i class="bi bi-people-fill me-2"></i>Users</h4>
              <div class="row g-3">
                <div class="col-md-12">
                  <div *ngIf="vendors.length === 0" class="text-muted small">No vendors added.</div>
                  <div class="table-responsive border rounded" *ngIf="vendors.length > 0">
                    <table class="table table-sm table-striped mb-0 align-middle">
                      <thead class="bg-light">
                        <tr>
                          <th class="ps-3 py-2" style="font-size: 12px">#</th>
                          <th class="py-2" style="font-size: 12px">Vendor Name</th>
                          <th class="py-2" style="font-size: 12px">Purpose</th>
                          <th class="py-2" style="font-size: 12px">Mobile No</th>
                          <th class="py-2" style="font-size: 12px">Email</th>
                          <th class="py-2" style="font-size: 12px">Delivery Address</th>
                          <th class="pe-3 py-2 text-center" style="font-size: 12px">Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let vendor of vendors.controls; let i = index">
                          <td class="ps-3 py-2 fw-medium" style="font-size: 13px">{{ i + 1 }}</td>
                          <td class="py-2" style="font-size: 13px">
                            {{ vendor.get('vendorName')?.value || 'Unnamed' }}
                          </td>
                          <td class="py-2" style="font-size: 13px">
                            {{ vendor.get('purpose')?.value || '-' }}
                          </td>
                          <td class="py-2" style="font-size: 13px">
                            {{ vendor.get('mobileNo')?.value || '-' }}
                          </td>
                          <td class="py-2" style="font-size: 13px">
                            {{ vendor.get('email')?.value || '-' }}
                          </td>
                          <td class="py-2" style="font-size: 13px">
                            {{ vendor.get('deliveryAddress')?.value || '-' }}
                          </td>
                          <td class="pe-3 py-2 text-center" style="font-size: 13px">
                            <span *ngIf="verifiedVendorMobiles.has(vendor.get('mobileNo')?.value)"
                              class="badge bg-success bg-opacity-10 text-success border border-success border-opacity-25 px-2 py-1">
                              <i class="bi bi-check-circle-fill me-1"></i> Verified
                            </span>
                            <button *ngIf="
                                !verifiedVendorMobiles.has(vendor.get('mobileNo')?.value) &&
                                vendor.get('mobileNo')?.valid
                              " type="button" class="btn btn-sm btn-outline-danger py-0 px-2"
                              style="font-size: 11px; border-radius: 4px"
                              (click)="initiateVendorOtp(vendor.get('mobileNo')?.value)">
                              Verify Now
                            </button>
                            <span *ngIf="
                                !verifiedVendorMobiles.has(vendor.get('mobileNo')?.value) &&
                                !vendor.get('mobileNo')?.valid
                              " class="text-danger" style="font-size: 11px">
                              Invalid Mobile
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <!-- Section 6: Documents -->
            <div class="preview-section mb-4">
              <h4 class="preview-section-title">
                <i class="bi bi-file-earmark-arrow-up-fill me-2"></i>Uploaded Documents
              </h4>
              <div class="row g-3">
                <div class="col-md-12">
                  <div *ngIf="getDocumentKeys().length === 0" class="text-muted small">
                    No documents uploaded.
                  </div>
                  <div class="d-flex flex-wrap gap-2">
                    <ng-container *ngFor="let key of getDocumentKeys()">
                      <div class="p-2 border rounded d-flex align-items-center justify-content-between bg-white"
                        style="width: calc(50% - 8px); min-width: 280px">
                        <div class="d-flex align-items-center">
                          <i class="bi bi-file-earmark-check-fill text-success fs-5 me-2"></i>
                          <div>
                            <div class="fw-semibold" style="font-size: 12px; color: #495057">
                              {{ docLabels[key] }}
                            </div>
                            <div class="text-muted" style="font-size: 11px">
                              {{ uploadedFiles[key]?.name || 'Document uploaded' }}
                            </div>
                          </div>
                        </div>
                        <button type="button" class="btn btn-sm btn-outline-primary py-1 px-2"
                          (click)="viewDocument(key)">
                          <i class="bi bi-eye"></i> View
                        </button>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Declaration -->
          <div class="declaration-box mt-4">
            <label class="d-flex align-items-start gap-3 cursor-pointer">
              <input type="checkbox" class="form-check-input flex-shrink-0 mt-1" formControlName="declarationCheck"
                style="width: 18px; height: 18px" />
              <span>
                I hereby declare that all the information provided in this application is true and
                correct to the best of my knowledge. I understand that any false information may
                result in rejection of this registration.
              </span>
            </label>
            <div *ngIf="
                registerForm.get('declarationCheck')?.touched &&
                !registerForm.get('declarationCheck')?.value
              " class="text-danger mt-2" style="font-size: 11.5px; font-weight: 500">
              You must need to accept the declaration to submit.
            </div>
          </div>

          <div class="form-navigation mt-4 pt-3 border-top d-flex justify-content-between align-items-center">
            <button type="button" class="btn-back" (click)="prevStep()">
              <i class="bi bi-arrow-left"></i> Back
            </button>
            <button type="button" class="btn-submit" (click)="submitRegistration()"
              [disabled]="isSubmitting || !registerForm.get('declarationCheck')?.value">
              <span *ngIf="!isSubmitting"><i class="bi bi-send-fill me-2"></i>Submit Registration</span>
              <span *ngIf="isSubmitting"><span class="spinner-border spinner-border-sm me-2"
                  role="status"></span>Submitting...</span>
            </button>
          </div>
        </div>

        <div class="register-login-link" *ngIf="activeStep < 5">
          Already have an account? <a routerLink="/login">Sign in here</a>
        </div>
      </form>
    </div>
  </main>

  <!-- Document Preview Modal -->
  <div class="doc-preview-overlay" *ngIf="previewDocumentUrl" (click)="closeDocumentPreview()">
    <div class="doc-preview-modal" (click)="$event.stopPropagation()">
      <div class="d-flex gap-2 position-absolute" style="top: 15px; right: 15px; z-index: 10">
        <button class="btn btn-sm btn-light d-flex align-items-center gap-1" (click)="downloadPreviewDocument()"
          title="Download Document" style="
            border-radius: 50%;
            width: 36px;
            height: 36px;
            justify-content: center;
            box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
          ">
          <i class="bi bi-download"></i>
        </button>
        <button class="doc-preview-close position-static" (click)="closeDocumentPreview()" style="margin: 0">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>
      <iframe [src]="previewDocumentUrl" class="doc-preview-frame"></iframe>
    </div>
  </div>
</div>